import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useRouter } from 'next/router';

import Link from '@components/Link';
import Button from '@components/Button';
import Navigation from '@components/Navigation';
import NavigatorLogo from '@components/navigator/NavigatorLogo';

import { useStickyHeader } from '@util/useStickyHeader';

import { packagesRoute } from '@util/routes';
import { packageSearchRoute } from '@util/routes';

import themeStyles from '@styles/themes.module.css';
import * as styles from './NavigatorNavbar.module.css';

const NavigatorNavbar = ({ mainMenu, initialTheme, withSearch = false }) => {
  const [isVisible, inStickyRange] = useStickyHeader();
  const [searchTerm, setSearchTerm] = useState('');
  const rootRef = useRef(null);
  const router = useRouter();

  const handleSearch = (e) => {
    e.preventDefault();
    const route = packageSearchRoute('all', searchTerm);
    router.push(route);
  };

  return (
    <header
      className={cn(styles.root, themeStyles.purple, {
        [styles.inStickyRange]: inStickyRange,
        [styles.sticky]: inStickyRange && isVisible,
        [styles.initialThemeDark]: initialTheme === 'dark',
        [styles.withSearch]: withSearch,
      })}
      role="banner"
      ref={rootRef}
    >
      <Link
        className={cn(styles.logo)}
        aria-label="Cloudsmith Navigator Home"
        href={packagesRoute()}
      >
        <NavigatorLogo />
      </Link>
      {withSearch && (
        <form className={styles.search} onSubmit={handleSearch}>
          <input
            className={styles.searchInput}
            type="text"
            value={searchTerm}
            placeholder="Search for another package..."
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className={styles.searchSubmit}>
            <Button size="small" variant="primary">
              Search
            </Button>
          </div>
        </form>
      )}
      <Navigation
        mainMenu={mainMenu}
        onMobileMenuOpen={() => {
          rootRef.current?.classList.add(styles.mobileMenuShowing);
        }}
        onMobileMenuClose={() => {
          rootRef.current?.classList.remove(styles.mobileMenuShowing);
        }}
        onSubmenuOpen={() => {
          rootRef.current?.classList.add(styles.secondaryNavigationShowing);
        }}
        onSubmenuClose={() => {
          rootRef.current?.classList.remove(styles.secondaryNavigationShowing);
        }}
      />
    </header>
  );
};

NavigatorNavbar.propTypes = {
  withSearch: PropTypes.bool,
};

export default NavigatorNavbar;
